import React, { Fragment, useRef } from 'react';
import { ToastProvider } from 'react-toast-notifications';
import language from '../../config/es';
import {
  getPermissions,
  findByConcept,
  findByCollectingEntity,
  createChannelEntityPayment,
  deleteChannelEntityPayment,
  updateChannelEntityPayment,
} from '../../redux/channelEntityPayment.duck';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import app from '../../config/application';
import { es_vacio } from '../../config/validate';
import { findBySocieties } from '../../redux/branch.duck';
import { findCountries } from '../../redux/society.duck';
import { findChannel } from '../../redux/channel.duck';
//Permissions
import dictionary from '../../config/dictionary';
//Session user
import SessionConfig from '../../config/session_config';
//Crud compartido
import {
  useCrudState,
  usePermissionGate,
} from '../../components/Crud/crudHooks';
import {
  buildEditColumn,
  createFormState,
  renderDeleteAction,
  saveActionOf,
  toIdList,
} from '../../components/Crud/crudHelpers';
import {
  CountrySelect,
  RequiredFieldsAlert,
  SelectField,
} from '../../components/Crud/CrudFields';
import {
  CrudButtons,
  CrudDataTable,
  CrudLoadingScreen,
  CrudPage,
} from '../../components/Crud/CrudLayout';

function findArrayElementByTitle(array, value) {
  return array.find((element) => {
    return element.value === value;
  });
}

const ChannelEntityPayment = () => {
  const ref = useRef();
  const dispatch = useAppDispatch();

  const {
    data,
    refreshState,
    updateState,
    viewNotification,
    handleSelectRow,
    initStateDelete,
    finishDelete,
  } = useCrudState({
    ...createFormState({ editTransaction: true, pendingData: true }),
    id: null,
    channelsEntity: [],
    collectionEntity: { value: 0, label: '', error: '', auth: '' },
    country: { value: 0, label: '', error: '', auth: '' },
    limitAmountEntity: [],
    responseCreate: [],
    responseEdit: [],
    responseView: [],
    dataRows: [],
    showloadingCountry: false,
    showloadingEntity: true,
    showloadingMoney: true,
    showLoadingChannel: true,
    table: true,
    lsChannel: [],
    channel: { value: 0, label: '', error: '', auth: '' },
    listMoney: [],
    money: { value: 0, label: '', error: '', auth: '' },
    countries: [],
    collectingEntity: { value: '', error: '' },
    minAmount: { value: '', error: '' },
    maxAmount: { value: '', error: '' },
    entities: [],
    action: dictionary.configApp.action,
    auth: JSON.parse(sessionStorage.getItem('user')),
  });
  data.country.auth = useSelector((store) => store.branchReducer.errorResponse);
  data.countries = useSelector((store) => store.societyReducer.countries);
  data.transactionsNotAssigned = useSelector(
    (store) => store.collectingEntityReducer.cEntities
  );
  data.listMoney = useSelector(
    (store) => store.channelEntityPaymentReducer.types
  );
  const { loadInit, msgRestricted, withPermission } = usePermissionGate({
    ref,
    data,
    dispatch,
    getPermissions,
    notify: viewNotification,
    onAllowed: () => {
      initColumns();
      void initData();
    },
  });
  const initData = async () => {
    await loadCountries();
    await loadTypes();
    data.pendingData = false;
    refreshState();
  };
  const loadCountries = async () => {
    await dispatch(findCountries(data.auth.id.user.userId));
    data.showloadingCountry = true;
    refreshState();
  };
  const loadTypes = async () => {
    await dispatch(findByConcept(app.data.types.typePayment));
    data.showloadingMoney = true;
  };
  const loadChannels = async (value) => {
    data.showLoadingChannel = false;
    data.lsChannel = await dispatch(findChannel(value.value));
    data.showLoadingChannel = true;
    updateState(true, 'showLoadingChannel');
  };
  const updateSelect = async (value, id) => {
    switch (id) {
      case 'collectingEntity':
        data.tranNotAssigned = value;
        data.collectingEntity.value = data.tranNotAssigned.value;
        data.collectionEntity.auth = '';
        data.channel.auth = language.messages.messageSelectChannel;
        void loadLimitsAmount(value);
        void loadChannels(value);
        initColumns();
        break;
      case 'country':
        data.country = value;
        data.country.auth = '';
        data.collectionEntity = { value: 0, label: '', error: '', auth: '' };
        void loadLimitsAmount(0);
        data.dataRows = [];
        data.collectionEntity.auth = language.messages.messageSelectEntity;
        updateState(false, 'showloadingEntity');
        await loadEntities();
        data.showloadingEntity = true;
        data.tranNotAssigned = { value: 0, label: '' };
        initColumns();
        break;
      case 'money':
        data.money = value;
        data.money.auth = '';
        data.money.auth = language.messages.messageSelectTypePayment;
        break;
      case 'channel':
        data.channel = value;
        data.channel.auth = '';
        data.channel.auth = language.messages.messageSelectTypePayment;
        break;
      default:
        break;
    }
    refreshState();
  };
  const loadLimitsAmount = async (value) => {
    data.pendingData = true;
    updateState(true, 'pendingData');
    data.limitAmountEntity = await dispatch(
      findByCollectingEntity('+' + value.value)
    );
    if (data.limitAmountEntity === language.messages.messageNoAccessView) {
      data.table = false;
      viewNotification(language.messages.messageNoAccessView, 'error');
    } else {
      initColumns();
    }
    data.pendingData = false;
    refreshState();
  };
  const initColumns = () => {
    data.columns = [
      buildEditColumn(handleButtonEdit, {
        name: language.messages.lblFunctions,
        width: '60px',
      }),
      {
        name: language.messages.channel.lblChannel,
        sortable: false,
        wrap: true,
        width: '130px',
        cell: (row) => (
          <div className="text-primary text-uppercase small">
            {row.channelCollectingEntity.type.name}
          </div>
        ),
      },
      {
        name: language.messages.titleTypePayment,
        sortable: false,
        wrap: true,
        width: '250px',
        cell: (row) => (
          <div className="small text-uppercase">{row.paymentType.name}</div>
        ),
      },
    ];
    refreshState();
  };
  const handleButtonEdit = (row) => {
    data.id = row.id;
    data.money.value = row.paymentType.id;
    data.money.label = findArrayElementByTitle(
      data.listMoney,
      row.paymentType.id
    ).label;
    data.channel.value = row.channelCollectingEntity.id;
    data.channel.label = findArrayElementByTitle(
      data.lsChannel,
      row.channelCollectingEntity.id
    ).label;
    refreshState();
  };
  const loadEntities = async () => {
    data.showloadingEntity = false;
    await dispatch(findBySocieties(data.country.value));
    updateState(true, 'showloadingEntity');
  };
  const loadEntitiesReload = async (value) => {
    updateState(false, 'showloadingEntity');
    await dispatch(findBySocieties(value));
    updateState(true, 'showloadingEntity');
  };
  const init = (value) => {
    clearForm();
    void loadLimitsAmount(value);
  };
  const clearForm = () => {
    data.enable = true;
    data.editType = true;
    data.id = null;
    data.channel = { value: 0, label: '', error: '', auth: '' };
    data.money = { value: 0, label: '', error: '', auth: '' };
  };
  const handleSaveResponse = (response, successMessage) => {
    if (response.status === 200) {
      if (response.data === 'EXIST') {
        viewNotification(
          language.messages.typePaymentExistChannelCollectingEntity,
          'error'
        );
        data.pendingData = false;
      } else {
        viewNotification(successMessage, 'success');
      }
    } else {
      viewNotification(language.messages.msmErrorExist, 'error');
      data.pendingData = false;
    }
  };
  const saveData = async () => {
    data.enable = false;
    validate();
    await withPermission(
      saveActionOf(data),
      async () => {
        if (data.errors.length === 0) {
          data.pendingData = true;
          refreshState();
          // En alta data.id es null, por lo que el json es el mismo
          let json = {
            id: data.id,
            channelCollectingEntity: {
              id: data.channel.value,
            },
            paymentType: {
              id: data.money.value,
            },
            status: 1,
            userAdmin: data.auth.id.user.username,
          };
          if (data.id === null) {
            let response = await dispatch(createChannelEntityPayment(json));
            handleSaveResponse(
              response,
              language.messages.msmRegisterSuccessFully
            );
          } else {
            let response = await dispatch(updateChannelEntityPayment(json));
            handleSaveResponse(response, language.messages.msmUpdated);
          }
          data.pendingData = false;
          data.enable = true;
          init(data.collectingEntity);
        } else {
          data.enable = true;
          viewNotification(language.messages.msmErrorForm, 'error');
        }
        refreshState();
      },
      cleaningForm
    );
  };
  const disableData = async () => {
    if (data.selectedRows.length > 0) {
      data.enable = false;
      refreshState();
      await withPermission(data.action.delete, async () => {
        let json = toIdList(data.selectedRows, {
          userAdmin: data.auth.id.user.userId,
        });
        initStateDelete(false);

        let response = await dispatch(deleteChannelEntityPayment(json));
        finishDelete(response.code === undefined, response.message, reloadData);
      });
    }
  };
  const validate = () => {
    clearError();
    if (
      data.collectingEntity.value === 0 ||
      es_vacio(data.collectingEntity.value)
    ) {
      data.errors.push('collectingEntity.error');
      data.collectingEntity.error = language.messages.warning_required_field;
    }
    if (data.country.value === 0 || es_vacio(data.country.value)) {
      data.errors.push('country.error');
      data.country.error = language.messages.warning_required_field;
    }
    if (data.money.value === 0 || es_vacio(data.money.value)) {
      data.errors.push('money.error');
      data.money.error = language.messages.warning_required_field;
    }
    if (data.channel.value === 0 || es_vacio(data.channel.value)) {
      data.errors.push('channel.error');
      data.channel.error = language.messages.warning_required_field;
    }
    refreshState();
  };
  const clearError = () => {
    data.errors = [];
    data.money.error = '';
    data.channel.error = '';
    data.collectingEntity.error = '';
    data.country.error = '';
  };
  const handleDelete = () => {
    void disableData();
  };
  const contextActions = renderDeleteAction(handleDelete, data.enable);
  const cleaningForm = () => {
    //loadLimitsAmount(0);
    clearError();
    clearForm();
    refreshState();
  };
  const reloadData = () => {
    data.pendingData = true;
    data.tranNotAssigned = { value: 0, label: '' };
    data.country = { value: 0, label: '', error: '', auth: '' };
    data.transactionsNotAssigned = [];
    data.collectingEntity = { value: '', error: '' };
    refreshState();
    void loadCountries();
    void loadEntitiesReload(0);
    void loadLimitsAmount(0);
    cleaningForm();
  };
  return (
    <Fragment>
      <br />
      <SessionConfig ref={ref} />
      {loadInit === true ? (
        <CrudLoadingScreen msgRestricted={msgRestricted} />
      ) : (
        <CrudPage
          formCol={{ md: 5, xl: 4 }}
          formTitle={language.messages.channel.register}
          form={
            <form autoComplete="off">
              <RequiredFieldsAlert />
              <CountrySelect
                data={data}
                col={{ md: 12 }}
                onChange={updateSelect}
              />
              <SelectField
                row
                col={{ md: 12 }}
                label={language.messages.titleCEntityForm}
                loading={data.showloadingEntity}
                isDisabled={data.id !== null}
                name="collectingEntity"
                options={data.transactionsNotAssigned}
                field={data.tranNotAssigned}
                error={data.collectingEntity.error}
                onChange={updateSelect}
                changeKey="collectingEntity"
              />
              <SelectField
                row
                col={{ md: 12 }}
                label={language.messages.channel.lblChannel}
                loading={data.showLoadingChannel}
                isDisabled={data.id !== null}
                name="channel"
                options={data.lsChannel}
                field={data.channel}
                onChange={updateSelect}
                changeKey="channel"
              />
              <SelectField
                row
                col={{ md: 12 }}
                label={language.messages.titleTypePayment}
                loading={data.showloadingMoney}
                name="money"
                options={data.listMoney}
                field={data.money}
                onChange={updateSelect}
                changeKey="money"
              />

              <CrudButtons
                data={data}
                withLoading
                onSave={saveData}
                onClear={cleaningForm}
                onReload={reloadData}
              />
            </form>
          }
          tableCol={{ md: 7, xl: 5 }}
          tableClassTitle=" text-uppercase text-capitalize"
          tableIcon="fa fa-list"
          tableTitle={language.messages.gridChannelEntityPaymentTitle}
          table={
            <CrudDataTable
              data={data}
              show={data.table}
              noHeader={es_vacio(data.tranNotAssigned.label)}
              title={data.country.label + ' ' + data.tranNotAssigned.label}
              rows={data.limitAmountEntity}
              onSelect={handleSelectRow}
              pointerOnHover={true}
              actions={contextActions}
            />
          }
        />
      )}
    </Fragment>
  );
};
const App = () => (
  <ToastProvider>
    <ChannelEntityPayment />
  </ToastProvider>
);
export default App;
